/** Junta classes ignorando falsy. Evita uma dependência só para isto. */
export function cn(...partes: (string | false | null | undefined)[]): string {
  return partes.filter(Boolean).join(' ')
}
